<template>
  <Container>
    <canvas ref="canvas" style="width: 100%; border: 1px solid #fff;" width="1080" height="1080" />
    <FormTextarea v-model="text" />
    <Button @click="download">
      Download
    </Button>
  </Container>
</template>
<script setup>
const canvas = ref(null)
const text = ref('')

onMounted(() => {
  const ctx = canvas.value.getContext('2d')
  const logo = new Image(2001, 478)
  logo.src = '/brand/logo/logo-fc-dia.png'

  watch(text, () => {
    ctx.fillStyle = '#A60000'
    ctx.fillRect(0, 0, 1080, 1080)
    ctx.fillStyle = '#ffffff'
    ctx.font = 'bold 80px HR'
    const lines = text.value.split('\n')
    const offset = lines.length
    for (let i = 1; i <= lines.length; i++) {
      ctx.fillText(lines[i - 1], 230, ((1000 - (100 * offset)) / 2) + (i * 100), 800)
    }

    const gradient = ctx.createLinearGradient(0, 900, 0, 1080)
    gradient.addColorStop(0, '#00000000')
    gradient.addColorStop(1, '#00000088')
    ctx.fillStyle = gradient
    ctx.fillRect(0, 900, 1080, 180)
    ctx.drawImage(logo, 730, 970, 330, 80)
  })
})

const download = () => {
  const link = document.createElement('a')
  link.download = 'download.png'
  link.href = canvas.value.toDataURL()
  link.click()
}

useHead({
  meta: [
    {
      key: 'robots',
      name: 'robots',
      content: 'noindex'
    }
  ]
})
</script>
